import { DependenciesInjection } from "app/di/DependencyInjection";
import { IOTSimListLookupImpl } from "../data/IOTSimListLookupImpl";
import { IIOTSimListLookupRepository } from "../domain/repositories/IIOTSimListLookupRepository";
import { IOTSimListLookupUseCase } from "../domain/useCases/IOTSimListLookupUseCase";
import { IOTSimListLookupViewModel } from "../presentation/viewModel/IOTSimListLookupViewModel";
import { IOTSimListLookupToken } from "./IOTSimListLookupToken";

export class IOTSimListLookupInjection {
  static initInjections() {
    DependenciesInjection.register<IIOTSimListLookupRepository>(
      IOTSimListLookupToken.IIOTSimListLookupRepository,
      IOTSimListLookupImpl,
      "otherRepo",
    );
    DependenciesInjection.register<IOTSimListLookupUseCase>(
      IOTSimListLookupToken.IOTSimListLookupUseCase,
      IOTSimListLookupUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<IOTSimListLookupViewModel>(
      IOTSimListLookupToken.IOTSimListLookupViewModel,
      IOTSimListLookupViewModel,
      "viewModel",
    );
  }

  static getIOTSimListLookupRepo() {
    return DependenciesInjection.getRepo<IIOTSimListLookupRepository>(
      IOTSimListLookupToken.IIOTSimListLookupRepository,
    );
  }

  static getIOTSimListLookupUseCase() {
    return DependenciesInjection.getRepo<IOTSimListLookupUseCase>(
      IOTSimListLookupToken.IOTSimListLookupUseCase,
    );
  }

  static getIOTSimListLookupViewModel() {
    return DependenciesInjection.getRepo<IOTSimListLookupViewModel>(
      IOTSimListLookupToken.IOTSimListLookupViewModel,
    );
  }
}
